<svelte:options customElement={{
    tag: 'account-update-info-panel',
    shadow: 'none',
    props: {
      firstName: { reflect: true, attribute: "first-name" },
      lastName: { reflect: true, attribute: 'last-name' },
      formAction: { reflect: true, attribute: "asp-action" },
      antiforgeryToken: { reflect: false, attribute: "antiforgery-token" },
      isPayrollManagedAccount: { reflect: true, attribute: "is-payroll-managed-account" },
    }
 }}
/>

<script lang="ts">
  import Header from '../wizard-header.svelte';
  import {Translations} from "../translations";
  import { onMount } from 'svelte';

  export let tenant: string = "";
  export let firstName: string = "";
  export let lastName: string = "";
  export let email: string = "";
  export let formAction: string = "";
  export let antiforgeryToken: string = "";
  export let isPayrollManagedAccount: boolean = false;
  
  let translations: Translations = new Translations(((window as any).localization) || {});
  let active: boolean = false;
  let wizard: any;
  let header: any;
  let steps: Array<string>;
  let step: number = 2;

  onMount(() => {
    steps =  [translations.get("Data"), translations.get("Verification"), translations.get("Password"), translations.get("Ready")];

    wizard.addEventListener("cancel", (event: Event) => onCancelClicked(event));
    wizard.addEventListener("stepChanged", (event: CustomEvent) => header.currentStep = event.detail - 2);
  });

  async function showWizard(): Promise<void> {
    wizard.step = 2;
    header.currentStep = wizard.step - 2;
    active = true;
  }
  
  function onCancelClicked(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    active = false;
  }
  
  async function onWizardClosed(): Promise<void> {
    active = false;
  }
</script>

<div class="wk-idp-info-panel">
  <img alt="" src="images/benutzerkonto.svg" class="wk-idp-info-panel-image wk-is-hidden-s"  />

  <!--
  <img alt="" src="images/account_landscape.png" class="wk-idp-info-panel-image wk-is-hidden-s"  />
  <img alt="" src="images/account_portrait.png" class="wk-idp-info-panel-image wk-is-hidden-xl wk-is-hidden-l wk-is-hidden-m wk-is-hidden-xs"  />
  -->  
  <div class="wk-idp-info-panel-description">
    <span class="wk-idp-info-panel-intro">{translations.get("Switching to the ADDISON user account")}</span>
    <span class="wk-idp-info-panel-title">{translations.get("Log in more easily")}</span>
    <span class="wk-idp-info-panel-subtitle">{@html translations.get("All you need to log in is your <b>e-mail address and a password</b> - simply switch to the new ADDISON user account in three steps")}</span>  
    <span class="wk-idp-info-panel-action-bar">
      <button class="wk-button" on:click|preventDefault|stopPropagation={showWizard}>{translations.get("Switch now")}</button>
    </span>
    <span class="wk-idp-info-panel-info">
      <a href="https://hilfecenter.addisononeclick.de/hc/de/articles/12312990247836-Wie-stelle-ich-meinen-Login-auf-E-Mail-Adresse-und-Passwort-um" target="_blank" rel="noopener">{translations.get("Further information on the ADDISON user account")}</a>
    </span>
  </div>
</div>


<wk-modal class="wk-modal-element footer-less-modal" {active} on:hide={onWizardClosed}>
  <div slot="header">
    <div class="wk-custom-modal-header">
      <div class="wk-modal-title">{translations.get("Conversion to the new ADDISON user account")}</div>
      <Header bind:this={header} {steps} />
    </div>  
  </div> 
  <div slot="body">
    <form class="wk-form" method="post" action="{formAction}">
      <input type="hidden" name="Tenant" value="{tenant}" />
      <input type="hidden" name="__RequestVerificationToken" value="{antiforgeryToken}" />

      <account-update-wizard bind:this={wizard} step={step} flow={1} {firstName} {lastName} {email} {isPayrollManagedAccount} {antiforgeryToken}></account-update-wizard>
    </form>
  </div>
</wk-modal>

<style lang="scss" global>
  .wk-idp-info-panel {
    background-color: #F6F6F6;
    display: flex;
    flex-direction: row;
    gap: 2rem;
    padding: 2rem;
    .wk-idp-info-panel-image {
      max-width: 185px;
      padding: 0;
      margin: 0;
    }
    .wk-idp-info-panel-description {
      display: flex;
      flex-direction: column;
      padding: 0;
      .wk-idp-info-panel-intro {
        color: #353535;
        line-height: 1rem;
        font-size: .75rem;
        font-weight: 500;
        text-transform: uppercase;
        padding-bottom: 1rem;
      }
      .wk-idp-info-panel-title {
        font-weight: 500;
        font-size: 1.5rem;
        line-height: 2rem;
      }
      .wk-idp-info-panel-subtitle {
        margin-top: 1rem;
      }
      .wk-idp-info-panel-info {
        margin-top: 1rem;
      }
      .wk-idp-info-panel-action-bar {
        margin-top: 1rem;
      }
    }    
  }

  .footer-less-modal {
    .wk-modal {
      .wk-modal-content {
        width: 44rem;

        .wk-modal-body {
          overflow-y: auto;
          padding: 0 2rem 2rem;
          position: relative;
          grid-row: 2;
          grid-column: 1;
        }

        .wk-modal-footer {
          display: none;
        }
        
      }
    }
  }
  .wk-custom-modal-header {
    display: flex;
    flex-direction: row;
    .wk-modal-title {
      flex: 1;
    }
  }  
</style>